export enum DefaultRoute {
	Login = "Login",
	Register = "Register",
}
